<div class="main-ag-grid-container flex-column">
    <mat-card class="h-100">
        <!-- Toolbar -->
        <div class="grid-toolbar">
            <!-- Grid Header -->
            <div class="grid-title">
                <h3>Style Color Store Detail Grid</h3>
            </div>
            <!-- Button Container -->
            <div class="grid-tool-panel-btn-container">
                <!-- Rows Selected User Feedback -->
                <caption *ngIf="selectedDistros.length > 0">
                    {{
                        selectedDistros.length
                    }}
                    Distro{{
                        selectedDistros.length === 1 ? '' : 's'
                    }}
                    Selected
                </caption>
                <!-- Drill In -->
                <span>
                    <!-- Save Grid Changes -->
                    <button
                        id="detail-save-button"
                        mat-raised-button
                        color="accent"
                        class="primary-split-button"
                        (click)="onSaveGridChanges($event)"
                        [disabled]="
                            loading ||
                            gridOptions.context.rebalancedRows.length === 0 ||
                            selectedDistros.length === 0 ||
                            gridOptions.context.uneditable_rows.length > 0 ||
                            gridOptions.context.rows_to_rebalance.length > 0
                        "
                    >
                        Save
                    </button>
                    <!-- More Options - Trigger-->
                    <button
                        id="split-button"
                        mat-raised-button
                        color="accent"
                        [matMenuTriggerFor]="moreOptions"
                        #tooltip="matTooltip"
                        matTooltip="More Options"
                        matTooltipClass="below"
                        [disabled]="loading"
                    >
                        <mat-icon aria-hidden="false" aria-label="More Options" class="m-0">menu_open</mat-icon>
                    </button>
                </span>
                <!-- More Options - Item -->
                <mat-menu #moreOptions="matMenu">
                    <!-- Return To Summary Grid -->
                    <button
                        mat-menu-item
                        color="accent"
                        class="menu-panel-accent-btn"
                        (click)="$event.stopPropagation(); onReturnToSummaryGrid($event); trigger.closeMenu()"
                    >
                        Return To Summary Grid
                    </button>
                    <mat-divider></mat-divider>
                    <!-- Rebalance -->
                    <button
                        mat-menu-item
                        color="accent"
                        class="menu-panel-accent-btn"
                        (click)="$event.stopPropagation(); onRebalance(); trigger.closeMenu()"
                        [disabled]="selectedDistros.length === 0 || gridOptions.context.uneditable_rows.length > 0"
                    >
                        Rebalance
                    </button>
                    <!-- Revert To system distros confirm modal-->
                    <app-confirm-popup
                        #confirmPopupRevert
                        (confirmModal)="onRevertToSystemDistros($event); trigger.closeMenu()"
                    ></app-confirm-popup>
                    <!--  on revert To system distros button -->
                    <button
                        mat-menu-item
                        color="accent"
                        class="menu-panel-accent-btn"
                        (click)="confirmPopupRevert.confirm($event, 'Revert Distros'); $event.stopPropagation()"
                        [disabled]="selectedDistros.length === 0 || gridOptions.context.uneditable_rows.length > 0"
                    >
                        Revert To System Distro
                    </button>
                    <!-- Confirm Popup for Reset Grid -->
                    <app-confirm-popup
                        #confirmPopupResetGrid
                        (confirmModal)="onResetGridData($event); trigger.closeMenu()"
                    ></app-confirm-popup>
                    <!-- Reset Grid Data -->
                    <button
                        mat-menu-item
                        color="accent"
                        class="menu-panel-warn-btn"
                        (click)="confirmPopupResetGrid.confirm($event, 'Reset Grid'); $event.stopPropagation()"
                        [disabled]="
                            ObjectKeys(gridOptions?.context?.updatedRows).length === 0 &&
                            gridOptions.context.rebalancedRows.length === 0
                        "
                    >
                        Reset Grid Data
                    </button>
                    <mat-divider></mat-divider>

                    <!--  Export Distro -- exports whatever distros are already loaded, no selection needed -->
                    <button
                        mat-menu-item
                        color="accent"
                        class="menu-panel-accent-btn"
                        [disabled]="loadedDistroCount === 0 || loadedDistroCount > 10 || !hasApprovedInLoadedGrid"
                        (click)="$event.stopPropagation(); onExport($event); trigger.closeMenu()"
                    >
                        Export Distro
                    </button>
                    <!--  Approve Distro -- approves whatever distros are already loaded, no selection needed -->
                    <button
                        mat-menu-item
                        color="accent"
                        class="menu-panel-accent-btn"
                        [disabled]="loadedDistroCount === 0 || hasApprovedInLoadedGrid || hasUnsavedChanges()"
                        (click)="$event.stopPropagation(); onApprove($event); trigger.closeMenu()"
                    >
                        Approve Distro
                    </button>
                    <!--  Unapprove Distro -- unapproves whatever distros are already loaded, no selection needed -->
                    <button
                        mat-menu-item
                        color="accent"
                        class="menu-panel-accent-btn"
                        [disabled]="loadedDistroCount === 0 || !allLoadedApproved"
                        (click)="$event.stopPropagation(); onUnapprove($event); trigger.closeMenu()"
                    >
                        Unapprove Distro
                    </button>
                    <mat-divider></mat-divider>

                    <!--  Visualize -->
                    <button
                        mat-menu-item
                        color="accent"
                        class="menu-panel-accent-btn"
                        [disabled]="
                            selectedDistros.length >= 2000 || (totalRowCount >= 2000 && selectedDistros.length === 0)
                        "
                        (click)="$event.stopPropagation(); onOpenVisualizeModal($event); trigger.closeMenu()"
                    >
                        Visualize
                    </button>
                </mat-menu>
            </div>
        </div>
        <!-- AG Grid -->
        <ag-grid-angular
            id="size-distro-management-detail-grid"
            class="ag-theme-alpine ag-grid-container"
            [gridOptions]="gridOptions"
            [cellSelection]="true"
            [attr.tool-panel]="true"
        ></ag-grid-angular>
    </mat-card>
</div>
